import React from "react";
import { ReviewsViewerSSR } from "tsi-common-react/src/apps/reviews/ReviewsViewerSSR/index";

import { templates } from "@reactivated";

export const Template = (
    props: templates.ReviewsPageTemplate,
): React.JSX.Element => {
    return (
        <ReviewsViewerSSR
            {...props}
            isCondensedView={true}
            sourceFilterWhitelist={props.show_sources ? [] : ["Sealy"]}
        />
    );
};
